// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2d8Hj","assignButton":"CreateEditEquipmentSchedule_assignButton__ZQ4FI"};